const mode = {
  EXPLICIT: 'EXPLICIT',
  IMPLICIT: 'IMPLICIT'
}

export default mode
